export default "__VITE_ASSET__Dw3nEkOq__"